import { formatDuration } from 'scheduler-lib';

export interface TaskProgress {
  percentage: number;
  color: 'green' | 'yellow' | 'red';
  label: string;
  showBar: boolean;
}

export const PROGRESS_COLORS = {
  green: 'bg-green-500',
  yellow: 'bg-yellow-500',
  red: 'bg-red-500',
} as const;

const NO_BAR: Readonly<TaskProgress> = Object.freeze({ percentage: 0, color: 'green', label: '', showBar: false });

export function getTaskProgress(actualMinutes: number, estimatedMinutes: number): TaskProgress {
  if (!Number.isFinite(actualMinutes) || !Number.isFinite(estimatedMinutes)
      || actualMinutes <= 0 || estimatedMinutes <= 0) {
    return NO_BAR;
  }

  const percentage = Math.round((actualMinutes / estimatedMinutes) * 100);

  let color: TaskProgress['color'];
  if (percentage >= 100) {
    color = 'red';
  } else if (percentage >= 80) {
    color = 'yellow';
  } else {
    color = 'green';
  }

  const label = `${formatDuration(actualMinutes)} / ~${formatDuration(estimatedMinutes)} (${percentage}%)`;

  return { percentage, color, label, showBar: true };
}
